import {createMuiTheme, responsiveFontSizes} from "@material-ui/core/styles";

export const customTheme = options => responsiveFontSizes(createMuiTheme(options))
